const team = [
  {
    cover: "https://avatars.githubusercontent.com/u/58693194?v=4",
    github: "https://github.com/DmitryAstapenko",
    name: "Dmitry Astapenko",
    role: "Team Lead",
    desc: [
      "Координиция проекта",
      "Роутинг",
      "Учебник",
      "Словарь",
      "Меню",
      "Страница игры",
    ],
  },
  {
    cover: "https://avatars.githubusercontent.com/u/32163526?v=4",
    github: "https://github.com/RamanNovikau",
    name: "Raman Novikau",
    role: "Developer",
    desc: [
      "Бэкенд",
      "Авторизация",
      "Учебник",
      'Игра "Саванна"',
      "Статистика",
      "Настройки",
    ],
  },
  {
    cover:
      "https://avatars.githubusercontent.com/u/63358804?s=400&u=bc1e3a8963159051621459fedc782e35d493bdf0&v=4",
    github: "https://github.com/naTpuk-ep",
    name: "Yauheni Piatrou",
    role: "Developer",
    desc: [
      "Главная страница",
      'Игра "Угадай слово"',
      "Игровая статистика",
      "Игровой уровень",
    ],
  },
  {
    cover: "https://avatars.githubusercontent.com/u/36677235?v=4",
    github: "https://github.com/zhenyamarinovich",
    name: "Zhenya Marinovich",
    role: "Developer",
    desc: ['Игра "Спринт"', 'Игра "Аудио-вызов"', "Юнит-тесты"],
  },
];

export default team;
